"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "altissimo": {
    "b216a6dc": [{
      "hkey": "a271eb82",
      "slug": "molino-mozzi-bittarelli",
      "name": "Molino-Mozzi-Bittarelli",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "a271eb82",
      "slug": "molino-mozzi-bittarelli",
      "name": "Molino-Mozzi-Bittarelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;